'use strict';

var index$1 = require('../../_virtual/index6.cjs');
var index = require('./node_modules/react-is/index.cjs');
var factoryWithTypeCheckers = require('./factoryWithTypeCheckers.cjs');
var factoryWithThrowingShims = require('./factoryWithThrowingShims.cjs');

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredPropTypes;

function requirePropTypes () {
	if (hasRequiredPropTypes) return index$1.__module.exports;
	hasRequiredPropTypes = 1;
	if (process.env.NODE_ENV !== 'production') {
	  var ReactIs = index.__require();

	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  index$1.__module.exports = /*@__PURE__*/ factoryWithTypeCheckers.__require()(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  index$1.__module.exports = /*@__PURE__*/ factoryWithThrowingShims.__require()();
	}
	return index$1.__module.exports;
}

exports.__require = requirePropTypes;
//# sourceMappingURL=index.cjs.map
